const postTenants = {
  toastr: 'Tenant added',
  toastr1: ' has been successfully added',
  toastrError: 'Tenant already registered',
  toastrError1: 'Enter another name'
};

export default postTenants;
